import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaUsers, FaHome, FaCogs, FaShieldAlt } from 'react-icons/fa';
import { useAuth } from '../../hooks/useAuth';

const Sidebar = () => {
  const location = useLocation();
  const { isAdmin } = useAuth();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h4>Hub Admin</h4>
        <p className="text-muted small">Gerenciamento Central</p>
      </div>
      
      <div className="sidebar-content">
        {/* Voltar ao Hub */}
        <Link 
          to="/hub" 
          className={`sidebar-menu-item ${isActive('/hub') ? 'active' : ''}`}
        >
          <FaHome className="menu-icon" />
          <span className="menu-label">Voltar ao Hub</span>
        </Link>

        {/* Separador */}
        <hr className="sidebar-divider" />

        {/* Administração - apenas para admins */}
        {isAdmin && (
          <>
            <Link 
              to="/admin/users" 
              className={`sidebar-menu-item ${isActive('/admin/users') ? 'active' : ''}`}
            >
              <FaUsers className="menu-icon" />
              <span className="menu-label">Gerenciar Usuários</span>
            </Link>

            <Link 
              to="/admin/profiles" 
              className={`sidebar-menu-item ${isActive('/admin/profiles') ? 'active' : ''}`}
            >
              <FaCogs className="menu-icon" />
              <span className="menu-label">Gerenciar Perfis</span>
            </Link>

            <Link 
              to="/admin/systems" 
              className={`sidebar-menu-item ${isActive('/admin/systems') ? 'active' : ''}`}
            >
              <FaCogs className="menu-icon" />
              <span className="menu-label">Gerenciar Sistemas</span>
            </Link>

            <Link 
              to="/admin/permissions" 
              className={`sidebar-menu-item ${isActive('/admin/permissions') ? 'active' : ''}`}
            >
              <FaShieldAlt className="menu-icon" />
              <span className="menu-label">Gerenciar Permissões</span>
            </Link>
          </>
        )}
      </div>

      <style jsx>{`
        .sidebar {
          width: 100%;
          height: 100vh;
          background: #000000; /* Alterado para preto */
          color: white;
          display: flex;
          flex-direction: column;
        }

        .sidebar-header {
          padding: 2rem 1.5rem 1rem;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .sidebar-header h4 {
          color: white;
          margin: 0;
          font-weight: 600;
        }

        .sidebar-content {
          flex: 1;
          padding: 1rem 0;
        }

        .sidebar-menu-item {
          display: flex;
          align-items: center;
          padding: 1rem 1.5rem;
          color: rgba(255, 255, 255, 0.8);
          text-decoration: none;
          transition: all 0.3s ease;
          border-left: 3px solid transparent;
        }

        .sidebar-menu-item:hover {
          background: rgba(255, 255, 255, 0.1);
          color: white;
          text-decoration: none;
          border-left-color: rgba(255, 255, 255, 0.5);
        }

        .sidebar-menu-item.active {
          background: rgba(255, 255, 255, 0.15);
          color: white;
          border-left-color: white;
        }

        .menu-icon {
          margin-right: 1rem;
          font-size: 1.1rem;
        }

        .menu-label {
          font-weight: 500;
        }

        .sidebar-divider {
          border: none;
          height: 1px;
          background: rgba(255, 255, 255, 0.1);
          margin: 1rem 1.5rem;
        }

        @media (max-width: 768px) {
          .sidebar {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1001;
            box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
          }
        }
      `}</style>
    </div>
  );
};

export default Sidebar;